var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('simplebar',{ref:"simplebar",staticClass:"scroll-box",style:({ height: _vm.height ? _vm.height + 'px' : '' }),on:{"scroll":_vm.scroll}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }